import { el } from "./dom.js";
import { api } from "../net/api.js";
import { RANK_TIERS } from "@neon-purge/shared";

/** Badge colour for a tier name (the API sends the name; colour lives in shared). */
function tierColor(name: string): string {
  return RANK_TIERS.find((t) => t.name === name)?.color ?? "#8a94a6";
}

/** Global leaderboard — top players by wins then kills. */
export function leaderboardScreen(onBack: () => void): HTMLElement {
  const screen = el("div", { class: "screen" });
  const panel = el("div", { class: "panel", style: "min-width:460px" });
  const body = el("div", { class: "hint", text: "loading…" });

  void api.getLeaderboard().then((rows) => {
    if (rows.length === 0) { body.textContent = "no games recorded yet — go win one!"; return; }
    body.replaceChildren(
      el("div", { class: "lb-row lb-head" },
        el("span", { text: "#" }), el("span", { text: "PLAYER" }),
        el("span", { text: "RANK" }),
        el("span", { text: "WINS" }), el("span", { text: "KILLS" }), el("span", { text: "K/D" }),
      ),
      ...rows.map((r, i) => {
        const kd = r.deaths > 0 ? (r.kills / r.deaths).toFixed(2) : String(r.kills);
        const me = r.username === api.account?.username;
        const rankCell = el("span", { text: r.rank ? `${r.rank} ${r.level ?? ""}`.trim() : "—" });
        if (r.rank) rankCell.style.color = tierColor(r.rank);
        return el("div", { class: `lb-row${me ? " lb-me" : ""}` },
          el("span", { text: String(i + 1) }),
          el("span", { text: r.username }),
          rankCell,
          el("span", { text: String(r.wins) }),
          el("span", { text: String(r.kills) }),
          el("span", { text: kd }),
        );
      }),
    );
  }).catch((e) => (body.textContent = (e as Error).message));

  const back = el("button", { class: "ghost wide mt1", text: "Back" });
  back.onclick = onBack;

  panel.append(
    el("div", { class: "brand", text: "NEON PURGE" }),
    el("div", { class: "brand-sub", text: "LEADERBOARD" }),
    body,
    back,
  );
  screen.append(panel);
  return screen;
}
